import InfoTooltip from 'components/InfoTooltip';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';

const COLOR_CLASS = {
    info: 'new:bg-paper',
    success: 'bg-success-light [&_[data-slot=label-card-content]]:text-primary',
    error: 'bg-error-light [&_[data-slot=label-card-content]]:text-fg-error',
} as const;

type LabelProps =
    | { labelId: string; labelValues?: ComponentProps<typeof FormattedMessage>['values']; label?: never }
    | { label: React.ReactNode; labelId?: never; labelValues?: never };

export const LabelCard = ({
    labelId,
    labelValues,
    label,
    tooltipText,
    tooltipValues,
    content,
    fontSize = 'normal',
    color = 'info',
}: LabelProps & {
    tooltipText?: string;
    tooltipValues?: ComponentProps<typeof FormattedMessage>['values'];
    content: React.ReactNode;
    fontSize?: 'normal' | 'large';
    color?: 'info' | 'success' | 'error';
}) => (
    <div
        className={cn(
            'border-divider new:border-0 new:shadow-card new:outline-hidden rounded-[7px] border px-4 py-3',
            COLOR_CLASS[color]
        )}
    >
        <div className="flex flex-row gap-1">
            <div className="text-body1">{labelId ? <FormattedMessage id={labelId} values={labelValues} /> : label}</div>
            {tooltipText ? <InfoTooltip text={tooltipText} values={tooltipValues} /> : null}
        </div>
        <div
            data-slot="label-card-content"
            className={cn(
                'mt-1.5 font-bold',
                fontSize === 'normal' ? 'text-base leading-6' : 'text-[1.875rem] leading-[2.375rem]'
            )}
        >
            {content}
        </div>
    </div>
);

export const getLabelCardColorByNumber = (value: number) => {
    if (value > 0) return 'success';
    if (value < 0) return 'error';
    return 'info';
};
